import { getAuth, onAuthStateChanged } from "firebase/auth";
import { app } from "./firebaseConfig";
import React, { useEffect, useState } from "react";

const auth = getAuth(app);

export default function SampleButton() {
  const [user, setUser] = useState(auth.currentUser);
  const [isVisible, setVisible] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setUser(user);
    });
    return () => unsubscribe();
  });

  const updateAchievement = async () => {
    if (loading) return; // 連続実行防止
    setLoading(true);

    const codeInputPrefix = document.getElementById("secret-code-prefix") as HTMLInputElement;
    const codeInputMain = document.getElementById("secret-code-main") as HTMLInputElement;
    const lastAnswer = document.getElementById("last-answer") as HTMLInputElement;
    try {
      if (user && codeInputPrefix.value.length === 3 && codeInputMain.value.length === 6) {
        await fetch("https://bad-assort.com/api/update-achievement", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            userId: user?.uid,
            achievementName: codeInputPrefix.value.toUpperCase(),
            timestamp: Date.now(),
            code: codeInputMain.value.toUpperCase(),
          }),
        })
          .then(response => response.json())
          .then(data =>
            alert("コードの入力を受け付けました\n正しいコードを入力している場合は実績が更新されます\nページをリロードしてください"));
      } else if (user && lastAnswer.value.length) {
        await fetch("https://bad-assort.com/api/verify-with-FA", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            userId: user?.uid,
            userName: user?.displayName,
            timestamp: Date.now(),
            code: lastAnswer.value,
          }),
        })
          .then(response => response.json())
          .then(data =>
            alert("最後の答えの入力を受け付けました\n正しい答えを入力している場合は実績が更新されます\nページをリロードしてください"));
      } else {
        alert("コードまたは最後の答えを正しく入力してください。");
      }
    } catch (error) {
      console.error("エラー:", error)
    } finally {
      setLoading(false);
      codeInputMain.value = "";
      codeInputPrefix.value = "";
      lastAnswer.value = "";
      collapse();
    }
  };

  const disp = () => {
    setVisible(true);
  }

  const collapse = () => {
    setVisible(false);
  }

  return (
    <>
      <button id="dispForm" className="open-modal" onClick={disp}>コード入力フォームはこちら</button>
      <div className="form-back" style={{ zIndex: `${isVisible ? 1500 : -1}`, opacity: `${isVisible ? 1 : 0}` }}>
        <form id="verify-form">
          <ul>
            <li>コードを入力する場合は半角英数字6桁で入力してください。英語は全て大文字で、I,Oは使用しません（全て数字の1または0になります）。</li>
            <li>過去に解いたことがあるゲーム、または協力プレイしたために自分のアカウントでプレイしなかったゲームの実績は、最終問題の回答をここに直接入力することで取得できます。対象となるのは以下の作品です：<ul><li><span style={{ textDecoration: "line-through" }}>Gothic</span><span style={{ color: "red" }}>対応終了しました</span></li><li>ビブリオワンダース！Another story</li></ul></li>
            <li>「神佑」は謎解きに使用したブラウザでログインすることにより、過去のプレイデータを読み込んで実績を取得することができます。</li>
            <li>上記の謎解き以外は解答入力による認証ができませんので、このフォームからは実績取得できません。お手数ですが、もう一度はじめからプレイし直してください。</li>
            <li>所定の回数入力を間違えると本機能はロックされます。その場合はお手数ですが<a href="mailto:contact.badassort@gmail.com">contact.badassort@gmail.com</a>までご連絡ください。</li>
          </ul>
          <div id="inputs">
            <p>
              <input type="text" id="secret-code-prefix" placeholder="***" maxLength={3} style={{ textAlign: "center" }}></input><span>-</span>
              <input type="text" id="secret-code-main" placeholder="******" maxLength={6} style={{ textAlign: "center" }}></input></p>
            <p>または</p>
            <input type="text" id="last-answer" placeholder="最後の答えを入力……" style={{ textAlign: "center" }}></input>
            <p>
              <button type="button" onClick={updateAchievement} disabled={loading}>{loading ? "処理中です..." : "送信"}</button>
              <button type="button" onClick={collapse}>閉じる</button></p>
          </div>
        </form>
      </div>
    </>
  )
}
